import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!email) {
      setStatus("error");
      return;
    }
    api
      .post("/newsletter/unsubscribe", { email })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [email]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full text-center">
        {status === "loading" && (
          <p className="text-sm text-[#5a5a5a]" data-testid="unsubscribe-loading">Processing your request…</p>
        )}
        {status === "done" && (
          <>
            <h1 className="font-serif text-3xl text-[#560216] mb-4" data-testid="unsubscribe-success">You've been unsubscribed</h1>
            <p className="text-sm text-[#5a5a5a] leading-relaxed">
              {email} has been removed from the LIRA mailing list. We're sorry to see you go — you're always welcome back.
            </p>
            <Link
              to="/"
              className="inline-block mt-8 bg-[#560216] text-white text-xs tracking-[0.2em] uppercase px-10 py-4 rounded-full hover:opacity-90 transition-opacity"
              data-testid="unsubscribe-home-link"
            >
              Return to LIRA
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-serif text-3xl text-[#560216] mb-4" data-testid="unsubscribe-error">Something went wrong</h1>
            <p className="text-sm text-[#5a5a5a] leading-relaxed">
              We couldn't process your unsubscribe request. Please try the link in your email again or contact us.
            </p>
            <Link
              to="/"
              className="inline-block mt-8 bg-[#560216] text-white text-xs tracking-[0.2em] uppercase px-10 py-4 rounded-full hover:opacity-90 transition-opacity"
            >
              Return to LIRA
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
